import { Component, OnInit } from "@angular/core";
import { ToastService } from "src/app/services/toast.service";

@Component({
  selector: "app-toast",
  templateUrl: "./toast.component.html",
  styleUrls: ["./toast.component.scss"],
})
export class ToastComponent implements OnInit {
  toasts: any[] = [];

  constructor(private _toastService: ToastService) {}

  ngOnInit(): void {
    this._toastService.onToastCall.subscribe((message: string) => {
      const id = Date.now();
      this.toasts.unshift({ id, message });
      this.initTimer(id);
    });
  }

  closeToast(id: number) {
    this.toasts = this.toasts.filter(toast => toast.id !== id);
  }

  async initTimer(id: number) {
    setTimeout(() => {
      this.closeToast(id);
    }, 5000);
  }
}
